module.exports = __webpack_public_path__ + "img/confusion.a3ca38ef.webp";